import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "项目", -1)
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "工作台", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "我的", -1)
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createBlock(_component_van_tabbar, {
    route: "",
    "inactive-color": "#949CA1",
    "active-color": "#1D5A93",
    placeholder: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/system/project"
      }, {
        icon: _withCtx((props) => [
          _createElementVNode("img", {
            src: 
            props.active
              ? require('@/assets/tabbar/home-a.png')
              : require('@/assets/tabbar/home.png')
          
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/system/workbench"
      }, {
        icon: _withCtx((props) => [
          _createElementVNode("img", {
            src: 
            props.active
              ? require('@/assets/tabbar/work-a.png')
              : require('@/assets/tabbar/work.png')
          
          }, null, 8, _hoisted_4)
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/system/myself"
      }, {
        icon: _withCtx((props) => [
          _createElementVNode("img", {
            src: 
            props.active
              ? require('@/assets/tabbar/mine-a.png')
              : require('@/assets/tabbar/mine.png')
          
          }, null, 8, _hoisted_6)
        ]),
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}